import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Wrapper = styled('div')`
text-align: center;
`;

export const Content = styled('div')`
${({ theme: { spacing, breakpoint } }) => `
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: ${spacing.px40};

    @media screen and (max-width: ${breakpoint.md}) {
        flex-direction: column;
    }
`}
`;

export const ImageWrapper = styled('div')`
  ${({ theme: { spacing, breakpoint } }) => `
    margin-right: ${spacing.px40};
    img {
        width: 75%;
    }

    @media screen and (max-width: ${breakpoint.md}) {
        margin: 0 0 ${spacing.px40};
        img {
            width: 90%;
        }
    }
  `}
`;

export const ContentInfo = styled('div')`
  ${({ theme: { breakpoint } }) => `
    text-align: left;
    width: 35%;
    @media screen and (max-width: ${breakpoint.md}) {
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 90%;
    }
  `}
`;

export const Body = styled('div')`
  ${({ theme: { colors, fontSize, spacing } }) => `
    p {
      color: ${colors.blueGrey2};
      font-size: ${fontSize.px16};
      margin-bottom: ${spacing.px10};
    }
  `}
`;

export const Button = styled(Link)`
  ${({ theme: { colors, spacing } }) => `
    border: 1px solid ${colors.blueGrey2};
    padding: ${spacing.px5} ${spacing.px10};
    color: ${colors.blueGrey2};
    border-radius: ${spacing.px10};
    margin: ${spacing.px5} ${spacing.px10} ${spacing.px5} 0;
    float: left;
    text-decoration: none;
    transition: all .3s;
    :hover {
        background: ${colors.blue3};
        color: ${colors.white};
        border: 1px solid ${colors.blue3};
    }
  `}
`;
